var ACCOUNTBASE = "//price.wuheung.com/";
var LOGINURLBASE = "//price.wuheung.com/";
var BASEURL = "//price.wuheung.com/";
// var BASEURL = "http://192.168.10.106:48080";
var CREURL = "//price.wuheung.com/";
// var ACCOUNTBASE = "";
// var LOGINURLBASE = "";
// var BASEURL = "";
// var CREURL = "";

// if (window.location.hostname.includes('localhost')|| window.location.hostname.includes('kemai.com')) {
//   ACCOUNTBASE = "//saasAdmin.kemai.com:8010";
//   LOGINURLBASE = "//account.kemai.com:8010";
//   BASEURL = "//www.kemai.com:8010";
//   CREURL = "//service.kemai.com:8010";
// }else if(window.location.hostname.includes('test.gitbo.cn')){
//   ACCOUNTBASE = "//saasAdmin.test.gitbo.cn";
//   LOGINURLBASE = "//account.test.gitbo.cn";
//   BASEURL = "//www.test.gitbo.cn";
//   CREURL = "//service.test.gitbo.cn";
// }else if(window.location.hostname.includes('codeji.cn')){
//   ACCOUNTBASE = "//saasAdmin.codeji.cn:8010";
//   LOGINURLBASE = "//account.codeji.cn:8010";
//   BASEURL = "//www.codeji.cn:8010";
//   CREURL = "//service.codeji.cn:8010";
// }

export { ACCOUNTBASE, LOGINURLBASE, BASEURL, CREURL };



// WEBPACK FOOTER //
// ./src/api/api.js